import { adminApi } from '../../api/adminApi';

const LIST_TAG = { type: 'ADMIN_FORM_FIELD_CONFIG', id: 'LIST' };

/**
 * Admin form field config endpoints. A scope is { scope: 'default' | 'ledger' | 'brokerGroup',
 * scopeId } (scopeId is null for the default).
 * - listFormFieldConfigs({ scope, scopeId, configType }): the configs that scope sees, one per
 *   field, each with its own scope and scopeId.
 * - batchUpdateFormFieldConfigs({ scope, scopeId, changes: [{ id, properties }] }): saves every
 *   change into the scope (a copy of config `id` when the scope has no config for that field
 *   yet), all or nothing.
 * - shareFormFieldConfigs({ docIds, targets: [{ scope, scopeId }] }): copies configs into any
 *   ledgers and broker groups, replacing theirs.
 */
export const adminFormFieldConfigsApi = adminApi.injectEndpoints({
	endpoints: (builder) => ({
		listFormFieldConfigs: builder.query({
			query: (body) => ({ url: '/form-field-configs/list', method: 'POST', body }),
			transformResponse: (response) => response.items,
			providesTags: [LIST_TAG],
		}),
		batchUpdateFormFieldConfigs: builder.mutation({
			query: (body) => ({ url: '/form-field-configs/batch/update', method: 'POST', body }),
			invalidatesTags: [LIST_TAG],
		}),
		shareFormFieldConfigs: builder.mutation({
			query: (body) => ({ url: '/form-field-configs/share', method: 'POST', body }),
			invalidatesTags: [LIST_TAG],
		}),
	}),
});

export const {
	useListFormFieldConfigsQuery,
	useBatchUpdateFormFieldConfigsMutation,
	useShareFormFieldConfigsMutation,
} = adminFormFieldConfigsApi;
